"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitStatus = exports.ResidentRole = void 0;
var ResidentRole;
(function (ResidentRole) {
    ResidentRole["Primary"] = "primary";
    ResidentRole["Secondary"] = "secondary";
})(ResidentRole = exports.ResidentRole || (exports.ResidentRole = {}));
var UnitStatus;
(function (UnitStatus) {
    UnitStatus["Occupied"] = "occupied";
    UnitStatus["Vacant"] = "vacant";
    UnitStatus["Pending"] = "pending";
})(UnitStatus = exports.UnitStatus || (exports.UnitStatus = {}));
